import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

interface firebaseParamsState {
  isParamsUpdated: boolean;
  [key: string]: any;  // This allows any new key with any value to be added
}



// Define the initial state using that type
const initialState : firebaseParamsState = {
  isParamsUpdated: false,
  bfl_shutdown : 'false',
  is_Las_Flow_Enabled : 'false'
}

export const firebaseParams = createSlice({
  name: 'firebaseParams',
  initialState,
  reducers: {
    updateFirebaseParams : (state , action : PayloadAction <typeof initialState>) => {
      // only update keys which are coming and add new keys and preserve initial state
        return{
        ...state,
        ...action.payload,
        isParamsUpdated:true,
      }

    },
    resetFirebaseParams : () => {
      return {...initialState}
    }
  },
})

export const { updateFirebaseParams, resetFirebaseParams } = firebaseParams.actions


export default firebaseParams.reducer